import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ClinicForm } from '@models/forms/clinic-form';
import { FormType } from '@models/forms/form-type.enum';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ClinicFormService {
  formsLoaded = new Subject<ClinicForm[]>();
  formSelected = new Subject<ClinicForm>();
  formUpdated = new Subject<ClinicForm>();
  formAdded = new Subject<ClinicForm>();
  formDeactivated = new Subject<ClinicForm>();
  formActivated = new Subject<ClinicForm>();
  formChangeCancelled = new Subject<ClinicForm>();
  formDeleted = new Subject<ClinicForm>();

  defaultId = 0;
  constructor(private http: HttpClient) {}

  getForms(includeInactive: boolean = false, formTypes: FormType[] = null) {
    return this.http.get<ClinicForm[]>(environment.baseUrl + 'api/ClinicForms', {
      params: formTypes ? { includeInactive, formTypes } : { includeInactive },
    });
  }

  getFormById(formId: number): Observable<ClinicForm> {
    return this.http.get<ClinicForm>(environment.baseUrl + 'api/ClinicForms/' + formId);
  }

  addForm(form: ClinicForm) {
    return this.http.post<ClinicForm>(environment.baseUrl + 'api/ClinicForms', form).pipe(
      map((addedForm) => {
        this.formAdded.next(addedForm);
        return addedForm;
      })
    );
  }

  updateForm(form: ClinicForm) {
    return this.http.put<ClinicForm>(environment.baseUrl + 'api/ClinicForms', form).pipe(
      map((updatedForm) => {
        this.formUpdated.next(updatedForm);
        return updatedForm;
      })
    );
  }

  deactivateForm(form: ClinicForm) {
    return this.http.put(environment.baseUrl + 'api/ClinicForms/SetFormActiveStatus/' + form.id + '/' + 0, {}).pipe(
      map(() => {
        this.formDeactivated.next(form);
        return;
      })
    );
  }

  deleteForm(form: ClinicForm) {
    return this.http.delete(environment.baseUrl + 'api/ClinicForms/' + form.id).pipe(
      map(() => {
        this.formDeleted.next(form);
        return;
      })
    );
  }

  activateForm(form: ClinicForm) {
    return this.http.put(environment.baseUrl + 'api/ClinicForms/SetFormActiveStatus/' + form.id + '/' + 1, {}).pipe(
      map(() => {
        this.formActivated.next(form);
        return;
      })
    );
  }
  cloneForm(formId: number) {
    return this.http.post<ClinicForm>(environment.baseUrl + 'api/ClinicForms/CloneClinicForm/' + formId, {}).pipe(
      map((clonedForm) => {
        this.formAdded.next(clonedForm);
        return clonedForm;
      })
    );
  }

  isFormInUse(formId: number): Observable<boolean> {
    return this.http.get<boolean>(environment.baseUrl + 'api/ClinicForms/' + formId + '/IsInUse');
  }
}
